<template>
  <v-col cols="12" v-show="$attrs.site_key">
    <Site :site-key="$attrs.site_key"></Site>
  </v-col>
</template>

<script>
import Site from '@/components/Site'

export default {
  name: 'sites',
  components: { Site },
}
</script>
